require('./rostersController');

"use strict";

angular.module('app.admin.rosters', [
    'app.admin.rosters.rostersController'
])
.config([
    '$stateProvider',
    function ($stateProvider) {
        $stateProvider.state('app.admin.rosters', {
            url: '/rosters',
            controller: 'app.admin.rosters.rostersController',
            templateUrl: 'components/admin/rosters/rostersView.html',
            title: 'Roster Manager'
        });
    }
]);


// WEBPACK FOOTER //
// ./app.v2/components/admin/rosters/rosters.js